import { z } from 'zod'

export const insightReportParamsSchema = z.object({
  reportId: z.union([z.coerce.number(), z.literal('demo')]),
})
export type InsightReportParams = z.infer<typeof insightReportParamsSchema>

export const insightReportSearchParamsSchema = z.object({
  workspaceId: z.coerce.number().optional(),
})
